import React, { Fragment, useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  Card,
  createFilterOptions,
  FormControl,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import {
  addProjectBilling,
  addProjectNature,
  addProjectStatus,
  addSalesStage,
  deleteProjectBilling,
  deleteProjectNature,
  deleteProjectStatus,
  deleteSalesStage,
  getProjectBilling,
  getProjectNature,
  getProjectStatus,
  getSalesStage,
  updateBilling,
  updateNature,
  updateSalesStage,
  updateStatus,
  getStakeholderRole,
  addStakeholderRole,
  deleteStakeholderRole,
  updateStakeholderRole
} from 'src/services/projectDetailService';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import {
  addBank,
  deleteBank,
  getAllBanks,
  updateBank,
  getAllGenders,
  addGender,
  updateGender,
  deleteGender,
  addMartialStatus,
  getAllMartialStatus,
  deleteMartialStatus,
  updateMartialStatus
} from 'src/services/employeeService';
import UpdateModal from './UpdateModal';
import './Configurations.css';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { useAppSelector } from 'src/hooks/hooks';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { getLeaveTypes, addLeaveType, deleteLeaveType } from 'src/services/yearPlannerService';

const filter = createFilterOptions<any>();

const ConfigurationSection = () => {
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const mainlabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: '1rem',
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 3,
    fontSize: '13px',
    fontWeight: 'bold',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const [billingCategories, setBillingCategories] = useState([]);
  const [valueBilling, setValueBilling] = useState<any>(null);

  const [projectNature, setProjectNature] = useState([]);
  const [valueNature, setValueNature] = useState<any>(null);

  const [projectStatus, setProjectStatus] = useState([]);
  const [valueStatus, setValueStatus] = useState<any>(null);

  const [salesStage, setSalesStage] = useState([]);
  const [valueSales, setValueSales] = useState<any>(null);

  const [banks, setBanks] = useState([]);
  const [valueBank, setValueBank] = useState<any>(null);

  const [gender, setGender] = useState([]);
  const [valueGender, setValueGender] = useState<any>(null);

  const [martialStatus, setMartialStatus] = useState([]);
  const [valueMartialStatus, setValueMartialStatus] = useState<any>(null);

  const [stakeholderRole, setStakeholderRole] = useState([]);
  const [valueStakeholderRole, setValueStakeholderRole] = useState<any>(null);

  const [leaveType, setLeaveType] = useState([]);
  const [valueLeaveType, setValueLeaveType] = useState<any>(null);

  const getAllMasterData = () => {
    getProjectBilling().then((res) => {
      const billingNames = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setBillingCategories(billingNames || []);
    });
    getProjectNature().then((res) => {
      const natureNames = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setProjectNature(natureNames || []);
    });
    getProjectStatus().then((res) => {
      const statusNames = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setProjectStatus(statusNames || []);
    });
    getSalesStage().then((res) => {
      const salesNames = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setSalesStage(salesNames || []);
    });
    getAllBanks().then((res) => {
      const banks = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setBanks(banks || []);
    });
    getAllGenders().then((res) => {
      const gender = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setGender(gender || []);
    });
    getAllMartialStatus().then((res) => {
      const martialStatus = res?.data?.map((dat) => {
        return {
          title: dat.name,
          id: dat.id
        };
      });
      setMartialStatus(martialStatus || []);
    });
    getStakeholderRole().then((res) => {
      const stakeholderRole = res?.data?.map((dat) => {
        return {
          title: dat.value,
          id: dat.id
        };
      });
      setStakeholderRole(stakeholderRole || []);
    });
    getLeaveTypes().then((res) => {
      const leaveType = res?.data?.map((dat) => {
        return {
          title: dat.description,
          id: dat.id
        };
      });
      setLeaveType(leaveType || []);
    });

  };

  useEffect(() => {
    getAllMasterData();
  }, []);

  const checkArrayIncludes = (arr, obj) => {
    return arr.some((val) => val?.title === obj?.title);
  };

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openConfirmationDelete, setOpenConfirmationDelete] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [toggledType, setToggledType] = useState('');
  const [data, setData] = useState<any>({});

  const toggleConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const toggleConfirmationDelete = () => {
    setOpenConfirmationDelete(!openConfirmationDelete);
  };

  const toggleUpdate = () => {
    setOpenUpdate(!openUpdate);
  };

  const dispatch = useDispatch();

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const addMasterData = (type) => {
    dispatch(AppActions.showLoader());

    if (type === 'billingCategory') {
      addProjectBilling(valueBilling?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added billing category successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueBilling(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add billing category');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'projectNature') {
      addProjectNature(valueNature?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added project nature successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueNature(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add project nature');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'projectStatus') {
      addProjectStatus(valueStatus?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added project status successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueStatus(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add project status');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'salesStage') {
      addSalesStage(valueSales?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added sales stage successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueSales(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add sales stage');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'banks') {
      addBank({ bankName: valueBank?.title })
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added bank name successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueBank(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add bank name');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'gender') {
      addGender({ Name: valueGender?.title })
          .then(() => {
            getAllMasterData();
            setSnackBarMessage('You have added gender successfully');
            setSnackbarSeverity('success');
            setSnackBarOpen(true);
            setValueGender(null);
            dispatch(AppActions.hideLoader());
          })
          .catch((e) => {
            setSnackBarMessage('Unable to add gender');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
            dispatch(AppActions.hideLoader());
          });
    }
    if (type === 'martialStatus') {
      addMartialStatus({ Name: valueMartialStatus?.title })
          .then(() => {
            getAllMasterData();
            setSnackBarMessage('You have added marital status successfully');
            setSnackbarSeverity('success');
            setSnackBarOpen(true);
            setValueMartialStatus(null);
            dispatch(AppActions.hideLoader());
          })
          .catch((e) => {
            setSnackBarMessage('Unable to add marital status');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
            dispatch(AppActions.hideLoader());
          });
    }
    if (type === 'stakeholderRole') {
      addStakeholderRole(valueStakeholderRole?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added stakeholder role successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueStakeholderRole(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add stakeholder role');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'leaveType') {
      addLeaveType(valueLeaveType?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have added holiday type successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueLeaveType(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to add holiday type');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
  };

  const deleteMasterData = (type) => {
    dispatch(AppActions.showLoader());
    if (type === 'billingCategory') {
      deleteProjectBilling(valueBilling?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have deleted billing category successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueBilling(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the billing category');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'projectNature') {
      deleteProjectNature(valueNature?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have deleted project nature successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueNature(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the project nature');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'projectStatus') {
      deleteProjectStatus(valueStatus?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have deleted project status successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueStatus(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the project status');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'salesStage') {
      deleteSalesStage(valueSales?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have deleted sales stage successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueStatus(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the sales stage');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'banks') {
      deleteBank(valueBank?.title)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have deleted bank name successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueBank(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the bank name');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'gender') {
      deleteGender(valueGender?.id)
          .then(() => {
            getAllMasterData();
            setSnackBarMessage('You have deleted gender successfully');
            setSnackbarSeverity('success');
            setSnackBarOpen(true);
            setValueGender(null);
            dispatch(AppActions.hideLoader());
          })
          .catch((e) => {
            setSnackBarMessage('You cannot delete the gender');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
            dispatch(AppActions.hideLoader());
          });
    }
    if (type === 'martialStatus') {
      deleteMartialStatus(valueMartialStatus?.id)
          .then(() => {
            getAllMasterData();
            setSnackBarMessage('You have deleted marital status successfully');
            setSnackbarSeverity('success');
            setSnackBarOpen(true);
            setValueMartialStatus(null);
            dispatch(AppActions.hideLoader());
          })
          .catch((e) => {
            setSnackBarMessage('You cannot delete the marital status');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
            dispatch(AppActions.hideLoader());
          });
    }
    if (type === 'stakeholderRole') {
      deleteStakeholderRole(valueStakeholderRole?.id)
        .then(() => {
          getAllMasterData();
          setSnackBarMessage('You have deleted stakeholder role successfully');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setValueStakeholderRole(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the stakeholder role');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
    if (type === 'leaveType') {
      deleteLeaveType(valueLeaveType?.id)
        .then((res) => {
          getAllMasterData();
          console.log(res)
          if(res.data.statusCode === 404){
            setSnackBarMessage('This Holiday Type cannot be deleted because it is already in use');
            setSnackbarSeverity('error');
          } else {
            setSnackBarMessage('You have deleted holiday type successfully');
            setSnackbarSeverity('success');
          }
          setSnackBarOpen(true);
          setValueLeaveType(null);
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('You cannot delete the holiday type');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
  };

  const updateMasterData = (type) => {
    if (type === 'billingCategory') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateBilling(body).then(() => {
        getAllMasterData();
        setValueBilling(null);
        toggleUpdate();
      });
    }
    if (type === 'projectNature') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateNature(body).then(() => {
        getAllMasterData();
        setValueNature(null);
        toggleUpdate();
      });
    }
    if (type === 'projectStatus') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateStatus(body).then(() => {
        getAllMasterData();
        setValueStatus(null);
        toggleUpdate();
      });
    }
    if (type === 'salesStage') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateSalesStage(body).then(() => {
        getAllMasterData();
        setValueSales(null);
        toggleUpdate();
      });
    }
    if (type === 'banks') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateBank(body).then(() => {
        getAllMasterData();
        setValueBank(null);
        toggleUpdate();
      });
    }
    if (type === 'martialStatus') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateMartialStatus(body).then(() => {
        getAllMasterData();
        setValueMartialStatus(null);
        toggleUpdate();
      });
    }
    if (type === 'stakeholderRole') {
      const body = {
        name: data.title,
        id: data.id
      };
      updateStakeholderRole(body).then(() => {
        getAllMasterData();
        setValueStakeholderRole(null);
        toggleUpdate();
      });
    }
  };

  const [billingError, setBillingError] = useState('');
  const [natureError, setNatureError] = useState('');
  const [saleError, setSaleError] = useState('');
  const [statusError, setStatusError] = useState('');
  const [bankError, setBankError] = useState('');
  const [genderError, setGenderError] = useState('');
  const [martialError, setMartialError] = useState('');
  const [stakeholderRoleError, setStakeholderRoleError] = useState('');
  const [leaveTypeError, setLeaveTypeError] = useState('');

  const { isLoading } = useAppSelector((state) => state.appReducer);

  return (
    <Fragment>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Configurations
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
      </Grid>
      <Card style={{ padding: '1rem' }}>

        <Grid item xs={6}>
          <Typography style={mainlabelStyle} variant="h4">
            Projects
          </Typography>
        </Grid>
        <Grid style={{ display: 'flex' }} container spacing={2}>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Billing Category
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  style={TextFieldStyle}
                  value={valueBilling}
                  onChange={(event, newValue) => {
                    if (newValue?.inputValue?.length > 30) {
                      setBillingError(
                        'Billing Category must not exceed 30 characters'
                      );
                    } else {
                      setBillingError('');
                      if (typeof newValue === 'string') {
                        setValueBilling({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValueBilling({
                          title: newValue.inputValue
                        });
                      } else {
                        setValueBilling(newValue);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (
                      inputValue !== '' &&
                      !isExisting &&
                      inputValue.trim().length > 0
                    ) {
                      filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={billingCategories}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.title}</li>
                  )}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Enter Billing Category"
                    />
                  )}
                  size="small"
                />
                {billingError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {billingError}&nbsp;
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              item
              xs={2}
            >
              {/* {checkArrayIncludes(billingCategories, valueBilling) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('billingCategories');
                    setData(valueBilling);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                className="no-hover"
                disabled={!valueBilling}
                type="button"
                onClick={() => {
                  setToggledType('billingCategory');
                  !checkArrayIncludes(billingCategories, valueBilling)
                    ? toggleConfirmation()
                    : toggleConfirmationDelete();
                }}
                sx={{
                  width: '100%',
                  mt: '1.25rem',
                  fontSize: '12px',
                  mr: 1,
                  background: '#adadad'
                }}
                variant="contained"
              >
                {`${
                  checkArrayIncludes(billingCategories, valueBilling)
                    ? 'Delete'
                    : 'Add'
                }`}
              </Button>
            </Grid>
          </Grid>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Project Nature
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  style={TextFieldStyle}
                  value={valueNature}
                  onChange={(event, newValue) => {
                    if (newValue?.inputValue?.length > 50) {
                      setNatureError(
                        'Project Nature must not exceed 50 characters'
                      );
                    } else {
                      setNatureError('');
                      if (typeof newValue === 'string') {
                        setValueNature({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValueNature({
                          title: newValue.inputValue
                        });
                      } else {
                        setValueNature(newValue);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (
                      inputValue !== '' &&
                      !isExisting &&
                      inputValue.trim().length > 0
                    ) {
                      filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo1"
                  options={projectNature}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.title}</li>
                  )}
                  freeSolo
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Enter Project Nature" />
                  )}
                  size="small"
                />
                {natureError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {natureError}&nbsp;
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              item
              xs={2}
            >
              {/* {checkArrayIncludes(projectNature, valueNature) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('projectNature');
                    setData(valueNature);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                className="no-hover"
                disabled={!valueNature || natureError !== ''}
                type="button"
                onClick={() => {
                  setToggledType('projectNature');
                  !checkArrayIncludes(projectNature, valueNature)
                    ? toggleConfirmation()
                    : toggleConfirmationDelete();
                }}
                sx={{
                  width: '100%',
                  mt: '1.25rem',
                  fontSize: '12px',
                  mr: 1,
                  background: '#adadad'
                }}
                variant="contained"
              >
                {`${
                  checkArrayIncludes(projectNature, valueNature)
                    ? 'Delete'
                    : 'Add'
                }`}
              </Button>
            </Grid>
          </Grid>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Pre-sale Stage
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  style={TextFieldStyle}
                  value={valueSales}
                  onChange={(event, newValue) => {
                    if (newValue?.inputValue?.length > 30) {
                      setSaleError(
                        'Pre-sale Stage must not exceed 30 characters'
                      );
                    } else {
                      setSaleError('');
                      if (typeof newValue === 'string') {
                        setValueSales({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValueSales({
                          title: newValue.inputValue
                        });
                      } else {
                        setValueSales(newValue);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (
                      inputValue !== '' &&
                      !isExisting &&
                      inputValue.trim().length > 0
                    ) {
                      filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={salesStage}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.title}</li>
                  )}
                  freeSolo
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Enter Pre-sale Stage" />
                  )}
                  size="small"
                />
                {saleError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {saleError}&nbsp;
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              item
              xs={2}
            >
              {/* {checkArrayIncludes(salesStage, valueSales) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('salesStage');
                    setData(valueSales);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    mr: 1,
                    fontSize: '12px',
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                className="no-hover"
                disabled={!valueSales}
                type="button"
                onClick={() => {
                  setToggledType('salesStage');
                  !checkArrayIncludes(salesStage, valueSales)
                    ? toggleConfirmation()
                    : toggleConfirmationDelete();
                }}
                sx={{
                  width: '100%',
                  mt: '1.25rem',
                  mr: 1,
                  fontSize: '12px',
                  background: '#adadad'
                }}
                variant="contained"
              >
                {`${
                  checkArrayIncludes(salesStage, valueSales) ? 'Delete' : 'Add'
                }`}
              </Button>
            </Grid>
          </Grid>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Project Status
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  style={TextFieldStyle}
                  value={valueStatus}
                  onChange={(event, newValue) => {
                    if (newValue?.inputValue?.length > 30) {
                      setStatusError(
                        'Project Status must not exceed 30 characters'
                      );
                    } else {
                      setStatusError('');
                      if (typeof newValue === 'string') {
                        setValueStatus({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValueStatus({
                          title: newValue.inputValue
                        });
                      } else {
                        setValueStatus(newValue);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (
                      inputValue !== '' &&
                      !isExisting &&
                      inputValue.trim().length > 0
                    ) {
                      filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={projectStatus}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.title}</li>
                  )}
                  freeSolo
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Enter Project Status" />
                  )}
                  size="small"
                />
                {statusError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {statusError}&nbsp;
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              item
              xs={2}
            >
              {/* {checkArrayIncludes(projectStatus, valueStatus) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('projectStatus');
                    setData(valueStatus);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                className="no-hover"
                disabled={!valueStatus}
                type="button"
                onClick={() => {
                  setToggledType('projectStatus');
                  !checkArrayIncludes(projectStatus, valueStatus)
                    ? toggleConfirmation()
                    : toggleConfirmationDelete();
                }}
                sx={{
                  width: '100%',
                  mt: '1.25rem',
                  fontSize: '12px',
                  mr: 1,
                  background: '#adadad'
                }}
                variant="contained"
              >
                {`${
                  checkArrayIncludes(projectStatus, valueStatus)
                    ? 'Delete'
                    : 'Add'
                }`}
              </Button>
            </Grid>
          </Grid>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Stakeholder Role
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  style={TextFieldStyle}
                  value={valueStakeholderRole}
                  onChange={(event, newValue) => {
                    if (newValue?.inputValue?.length > 30) {
                      setStakeholderRoleError(
                        'Stakeholder Role must not exceed 30 characters'
                      );
                    } else {
                      setStakeholderRoleError('');
                      if (typeof newValue === 'string') {
                        setValueStakeholderRole({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValueStakeholderRole({
                          title: newValue.inputValue
                        });
                      } else {
                        setValueStakeholderRole(newValue);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (
                      inputValue !== '' &&
                      !isExisting &&
                      inputValue.trim().length > 0
                    ) {
                      filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={stakeholderRole}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.title}</li>
                  )}
                  freeSolo
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Enter Stakeholder Role" />
                  )}
                  size="small"
                />
                {stakeholderRoleError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {stakeholderRoleError}&nbsp;
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              item
              xs={2}
            >
              <Button
                className="no-hover"
                disabled={!valueStakeholderRole}
                type="button"
                onClick={() => {
                  setToggledType('stakeholderRole');
                  !checkArrayIncludes(stakeholderRole, valueStakeholderRole)
                    ? toggleConfirmation()
                    : toggleConfirmationDelete();
                }}
                sx={{
                  width: '100%',
                  mt: '1.25rem',
                  fontSize: '12px',
                  mr: 1,
                  background: '#adadad'
                }}
                variant="contained"
              >
                {`${
                  checkArrayIncludes(stakeholderRole, valueStakeholderRole)
                    ? 'Delete'
                    : 'Add'
                }`}
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6} style={{ marginTop: '1rem' }}>
          <Typography style={mainlabelStyle} variant="h4">
            Employees
          </Typography>
        </Grid>
        <Grid style={{ display: 'flex' }} container spacing={2}>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Gender
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                    fullWidth
                    style={TextFieldStyle}
                    value={valueGender}
                    onChange={(event, newValue) => {
                      if (newValue?.inputValue?.length > 50) {
                        setGenderError('Gender Name must not exceed 50 characters');
                      } else {
                        setGenderError('');
                        if (typeof newValue === 'string') {
                          setValueGender({
                            title: newValue
                          });
                        } else if (newValue && newValue.inputValue) {
                          // Create a new value from the user input
                          setValueGender({
                            title: newValue.inputValue
                          });
                        } else {
                          setValueGender(newValue);
                        }
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                          (option) => inputValue === option.title
                      );
                      if (
                          inputValue !== '' &&
                          !isExisting &&
                          inputValue.trim().length > 0
                      ) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`
                        });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={gender}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(props, option) => (
                        <li {...props}>{option.title}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Enter Gender Name" />
                    )}
                    size="small"
                />
                {genderError && (
                    <Typography
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                          fontSize: '11px'
                        }}
                        color="red"
                    >
                      {genderError}&nbsp;
                    </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                item
                xs={2}
            >
              {/* {checkArrayIncludes(banks, valueBank) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('banks');
                    setData(valueBank);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                  className="no-hover"
                  disabled={!valueGender}
                  type="button"
                  onClick={() => {
                    setToggledType('gender');
                    !checkArrayIncludes(gender, valueGender)
                        ? toggleConfirmation()
                        : toggleConfirmationDelete();
                  }}
                  sx={{
                    width: '100%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
              >
                {`${checkArrayIncludes(gender, valueGender) ? 'Delete' : 'Add'}`}
              </Button>
            </Grid>
          </Grid>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
              Marital  status
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                    fullWidth
                    style={TextFieldStyle}
                    value={valueMartialStatus}
                    onChange={(event, newValue) => {
                      if (newValue?.inputValue?.length > 50) {
                        setMartialError('Marital Status Name must not exceed 50 characters');
                      } else {
                        setMartialError('');
                        if (typeof newValue === 'string') {
                          setValueMartialStatus({
                            title: newValue
                          });
                        } else if (newValue && newValue.inputValue) {
                          // Create a new value from the user input
                          setValueMartialStatus({
                            title: newValue.inputValue
                          });
                        } else {
                          setValueMartialStatus(newValue);
                        }
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                          (option) => inputValue === option.title
                      );
                      if (
                          inputValue !== '' &&
                          !isExisting &&
                          inputValue.trim().length > 0
                      ) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`
                        });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={martialStatus}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(props, option) => (
                        <li {...props}>{option.title}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Enter Marital Status Name" />
                    )}
                    size="small"
                />
                {martialError && (
                    <Typography
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                          fontSize: '11px'
                        }}
                        color="red"
                    >
                      {martialError}&nbsp;
                    </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                item
                xs={2}
            >
              {/* {checkArrayIncludes(banks, valueBank) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('banks');
                    setData(valueBank);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                  className="no-hover"
                  disabled={!valueMartialStatus}
                  type="button"
                  onClick={() => {
                    setToggledType('martialStatus');
                    !checkArrayIncludes(martialStatus, valueMartialStatus)
                        ? toggleConfirmation()
                        : toggleConfirmationDelete();
                  }}
                  sx={{
                    width: '100%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
              >
                {`${checkArrayIncludes(martialStatus, valueMartialStatus) ? 'Delete' : 'Add'}`}
              </Button>
            </Grid>
          </Grid>
          <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
                Banks
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                    fullWidth
                    style={TextFieldStyle}
                    value={valueBank}
                    onChange={(event, newValue) => {
                      if (newValue?.inputValue?.length > 50) {
                        setBankError('Bank Name must not exceed 50 characters');
                      } else {
                        setBankError('');
                        if (typeof newValue === 'string') {
                          setValueBank({
                            title: newValue
                          });
                        } else if (newValue && newValue.inputValue) {
                          // Create a new value from the user input
                          setValueBank({
                            title: newValue.inputValue
                          });
                        } else {
                          setValueBank(newValue);
                        }
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                          (option) => inputValue === option.title
                      );
                      if (
                          inputValue !== '' &&
                          !isExisting &&
                          inputValue.trim().length > 0
                      ) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`
                        });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={banks}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(props, option) => (
                        <li {...props}>{option.title}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Enter Bank Name" />
                    )}
                    size="small"
                />
                {bankError && (
                    <Typography
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                          fontSize: '11px'
                        }}
                        color="red"
                    >
                      {bankError}&nbsp;
                    </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                item
                xs={2}
            >
              {/* {checkArrayIncludes(banks, valueBank) && (
                <Button
                  className="no-hover"
                  type="button"
                  onClick={() => {
                    setToggledType('banks');
                    setData(valueBank);
                    toggleUpdate();
                  }}
                  sx={{
                    width: '50%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
                >
                  Update
                </Button>
              )} */}
              <Button
                  className="no-hover"
                  disabled={!valueBank}
                  type="button"
                  onClick={() => {
                    setToggledType('banks');
                    !checkArrayIncludes(banks, valueBank)
                        ? toggleConfirmation()
                        : toggleConfirmationDelete();
                  }}
                  sx={{
                    width: '100%',
                    mt: '1.25rem',
                    fontSize: '12px',
                    mr: 1,
                    background: '#adadad'
                  }}
                  variant="contained"
              >
                {`${checkArrayIncludes(banks, valueBank) ? 'Delete' : 'Add'}`}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        
        <Grid item xs={6} style={{ marginTop: '1rem' }}>
          <Typography style={mainlabelStyle} variant="h4">
           Holidays 
          </Typography>
        </Grid>
        <Grid display="flex" style={{ alignItems: 'center' }} item xs={6}>
            <Grid item xs={10}>
              <Typography fontWeight="light" style={LabelStyle} variant="h5">
              Holiday Type
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  style={TextFieldStyle}
                  value={valueLeaveType}
                  onChange={(event, newValue) => {
                    if (newValue?.inputValue?.length > 30) {
                      setLeaveTypeError(
                        'Holiday type must not exceed 30 characters'
                      );
                    } else {
                      setLeaveTypeError('');
                      if (typeof newValue === 'string') {
                        setValueLeaveType({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValueLeaveType({
                          title: newValue.inputValue
                        });
                      } else {
                        setValueLeaveType(newValue);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (
                      inputValue !== '' &&
                      !isExisting &&
                      inputValue.trim().length > 0
                    ) {
                      filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={leaveType}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.title}</li>
                  )}
                  freeSolo
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Enter Holiday Type" />
                  )}
                  size="small"
                />
                {leaveTypeError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {leaveTypeError}&nbsp;
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              item
              xs={2}
            >
              <Button
                className="no-hover"
                disabled={!valueLeaveType}
                type="button"
                onClick={() => {
                  setToggledType('leaveType');
                  !checkArrayIncludes(leaveType, valueLeaveType)
                    ? toggleConfirmation()
                    : toggleConfirmationDelete();
                }}
                sx={{
                  width: '100%',
                  mt: '1.25rem',
                  fontSize: '12px',
                  mr: 1,
                  background: '#adadad'
                }}
                variant="contained"
              >
                {`${
                  checkArrayIncludes(leaveType, valueLeaveType)
                    ? 'Delete'
                    : 'Add'
                }`}
              </Button>
            </Grid>
          </Grid>


      </Card>
      <ConfirmationModal
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure you want to add?`}
        onConfirm={() => {
          addMasterData(toggledType);
          toggleConfirmation();
        }}
        noToggle={toggleConfirmation}
        isLoading={isLoading}
      />
      <ConfirmationModal
        open={openConfirmationDelete}
        isLoading={isLoading}
        toggle={toggleConfirmationDelete}
        message={`Are you sure you want to delete?`}
        onConfirm={() => {
          deleteMasterData(toggledType);
          toggleConfirmationDelete();
        }}
        noToggle={toggleConfirmationDelete}
      />
      <UpdateModal
        open={openUpdate}
        toggle={toggleUpdate}
        setData={setData}
        data={data}
        onUpdate={() => updateMasterData(toggledType)}
      />
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
    </Fragment>
  );
};

export default ConfigurationSection;
